import React, { useState } from 'react';
import { Typography, makeStyles } from '@material-ui/core';
import TablePreviewXLSX from '../StepUploadFIleData/TablePreviewXLSX';
import TemplateVisualizer from './TemplateRender';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles(({
  container: {
    padding: '40px'
  },
  containerTable: {
    display: 'flex',
    justifyContent: 'center',
    paddingTop: '16px'
  },
  titles: {
    marginTop: 30,
    marginBottom: 30
  }
}));

const StepPrevisualization = ({ data, onChange }) => {
  const { t } = useTranslation();
  const [excelData] = useState(data.step2.excelData);
  const [selectedDataItem, setSelectedDataItem] = useState(null);
  const headersTable = excelData ? Object.keys(excelData[0]) : [];

  const classes = useStyles();
  return (
    <div className={classes.container}>
      <div>
        <div className={classes.titles}>
          <Typography variant='h4' align='left'>{t('wizardBulkNotification:recipientData')}</Typography>
        </div>
        <div>
          <TablePreviewXLSX setSelectedDataItem={setSelectedDataItem} headers={headersTable} rows={excelData} />
        </div>
      </div>
      <div>
        <div className={classes.titles}>
          <Typography variant='h4' align='left'>{t('wizardBulkNotification:messagePrevisualization')}</Typography>
        </div>

        <div>
          <TemplateVisualizer data={data} selectedDataItem={selectedDataItem} />

        </div>
      </div>

    </div>

  );
};

export default StepPrevisualization;
